export function MicrosoftIcon({
  className = 'h-4 w-4',
}: {
  className?: string
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 1h10.5v10.5H1z" fill="#F25022" />
      <path d="M12.5 1H23v10.5H12.5z" fill="#7FBA00" />
      <path d="M1 12.5h10.5V23H1z" fill="#00A4EF" />
      <path d="M12.5 12.5H23V23H12.5z" fill="#FFB900" />
    </svg>
  )
}
